import React, { useContext, useEffect } from "react";
import UserContext from "../components/User_Context.js";
import EditorPage from "../components/textEditor/pages/EditorPage.js";
import { useTranslation } from "react-i18next";
import * as menu from "../assets/menus/menu.js";
import "./ai_editor_screen.css";
import * as breadcrumb from "../components/ui/breadcrumb.js";

/**
 * AI Editor Screen
 * Wrapper screen that integrates the EditorPage component into the AI Plan application
 */
function AI_Editor_Screen() {
  const { currentUser } = useContext(UserContext);
  const { t } = useTranslation();

  // Initialize i18n labels for editor screen
  // useEffect(() => {
  //   try {
  //     const i18n = menu.getI18n();
  //     // Labels are loaded globally via menu.js
  //   } catch (error) {
  //     console.log("Error initializing i18n labels:", error);
  //   }

  
  // }, []);

  const setBreadCrumb = (params) => {
    var path = [{
        link: "/",
        name: t('home', { ns: 'labels' })
    },
    {
        link: "/admin/organization/business_units",
        name: t('admin', { ns: 'labels' })
    },
    {
        link: "/admin/organization/business_units",
        name: t('organizationalChart', { ns: 'labels' })
    }
    ];
    breadcrumb.set(path);
}


  useEffect(() => {
    (async () => {
        // setBreadCrumb();
        menu.write({ user: currentUser() });
    })();
}, []);
    return (
      <div className="d-flex flex-column" style={{ height: '100vh' }}>

          {/* ─────────────────────────────────────────────────────────────
          1) HEADER + TOOLBAR (non scorre mai)
          ───────────────────────────────────────────────────────────── */}
          
         {/* <header className="bg-white shadow-sm">
              <div className="container-fluid d-flex justify-content-between align-items-center py-2">
                  
                   <ol className="breadcrumb mb-0"></ol> 

                 
                  <div className="d-flex gap-3">
                      <a
                          className="text-primary fs-13"
                          onClick={(e) => {
                          }}
                          role="button"
                          title={t('saveThisData', { ns: 'labels' })}
                      >
                          <i className="fa-solid fa-floppy-disk fa-2x"></i>
                      </a>

                     
                  </div>
              </div>
          </header>
*/}
          {/* ─────────────────────────────────────────────────────────────
          2) ZONA SCROLLABILE
          ───────────────────────────────────────────────────────────── */}
          <main className="flex-grow-1 ">
              <div className="container-fluid p-0">
                  <div className="row">
                      <div className="col-xl-12">
                          <div className="card">
                              <div className="card-body p-0">
                                
                                    <EditorPage/>
                                  
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </main>
      </div>
  )
}

export { AI_Editor_Screen };
